import * as React from "react";

const Undo: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 20,
    color1 = "#4A4A4A",
    className,
}) => (
    <svg focusable="false" className={className} viewBox="0 0 20 20" width={size} height={size}>
        <g stroke={color1} strokeWidth="2" fill="none" strokeLinecap="round">
            <path d="M6.235 6.195l-5.019.027.025-5.021" />
            <path d="M3.63 15.95c3.35 3.351 8.861 3.27 12.31-.18 3.449-3.448 3.53-8.96.18-12.309-3.35-3.35-8.862-3.27-12.31.18A8.987 8.987 0 002 6.216" />
        </g>
    </svg>
);

export const UndoSrc: React.FC<{ disabled: boolean }> = ({ disabled }) => {
    const fillValue = disabled ? "#9E9E9E" : "#0037FF";

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
            <path
                d="M16.9844 8C16.9844 11.875 13.8281 15 9.98438 15C7.79688 15 5.79688 14.0312 4.45312 12.3125C4.26562 12.0938 4.32812 11.7812 4.54688 11.625C4.76562 11.4375 5.07812 11.5 5.23438 11.7188C6.39062 13.1875 8.10938 14 9.98438 14C13.2656 14 15.9844 11.3125 15.9844 8C15.9844 4.71875 13.2656 2 9.98438 2C7.82812 2 5.85938 3.15625 4.79688 5H7.48438C7.73438 5 7.98438 5.25 7.98438 5.5C7.98438 5.78125 7.73438 6 7.48438 6H3.48438C3.20312 6 2.98438 5.78125 2.98438 5.5V1.5C2.98438 1.25 3.20312 1 3.48438 1C3.73438 1 3.98438 1.25 3.98438 1.5V4.4375C5.23438 2.3125 7.48438 1.03125 9.98438 1.03125C13.8281 1.03125 16.9844 4.15625 16.9844 8Z"
                fill={fillValue}
            />
        </svg>
    );
};

export default React.memo(Undo);
